import React from 'react';
import NotAuthButtonsV1 from '../components/NotAuthButtons.v1';
import AuthedV1 from '../components/Authed.v1';
import { combineTemplate } from '@/lib/templateSwitch';
import DefaultTemplate from './template.default';
import LanguageButton from '../components/LanguageButton';

const NotAuthButtons = combineTemplate(DefaultTemplate.NotAuthButtons, [
  {
    name: 'comNotAuthButtons',
    component: <NotAuthButtonsV1 />,
  },
  {
    name: 'comLanguageContent',
    component: <LanguageButton />,
  },
]);

const Authed = combineTemplate(DefaultTemplate.Authed, [
  {
    name: 'comAuthedContent',
    component: <AuthedV1 />,
  },
  {
    name: 'comLanguageContent',
    component: <LanguageButton />,
  },
]);

export default {
  NotAuthButtons,
  Authed,
};
